import { Component, OnInit, AfterViewInit, Renderer2 } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { CommonService } from 'src/app/services/Common-function/common.service';

@Component({
  selector: 'ipm-error-page',
  templateUrl: './error-page.component.html',
  styleUrls: ['./error-page.component.scss']
})
export class ErrorPageComponent implements OnInit,  AfterViewInit{
    constructor(public routerActivated: ActivatedRoute,
      public commonService: CommonService,
      private renderer: Renderer2 ) {}
    
    
    ngOnInit(): void {
      this.routerActivated.data.subscribe( (data:Data) => {
        this.commonService.setTitleService(data['title'])
      });
    }

    /**
   * Back to the previous page 
   */
    goBack() {
      window.history.back();
    }

    ngAfterViewInit(): void {
      setTimeout(() => {
        let loader = this.renderer.selectRootElement('#loader');
        this.renderer.setStyle(loader, 'display', 'none');
      });
    }
}
